/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/member-delimiter-style */

/* eslint-disable no-use-before-define */

/* eslint-disable @typescript-eslint/naming-convention */

export enum ComponentTypes {
  Interests = 'interests',
  Spaces = 'spaces',
  Achievements = 'achievements',
  Activity = 'activity',
  Discord = 'discord',
  Certificates = 'certificates',
  Skills = 'skills',
  Education = 'education',
  Experience = 'experience',
}

export enum SocialMediaTypes {
  Twitter = 'Twitter',
  LinkedIn = 'LinkedIn',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  GitHub = 'GitHub',
  Phone = 'Phone',
  Email = 'Email',
}

export interface IDefault {
  type: ComponentTypes;
  visible: boolean;
}

export interface ISocialMedia {
  type: SocialMediaTypes;
  userName: string;
  visible: boolean;
}

export interface IBasicSection {
  visible: boolean;
  value: string;
}
export interface IBasic {
  profilePicture?: string;
  firstName: string; // same as in settings/profile page
  lastName: string; // same as in settings/profile page
  aboutMe?: string;
  phone: IBasicSection;
  email: IBasicSection;
  website: IBasicSection;
  dateOfBirth?: string;
  currentJobTitle?: string;
}

export type TagType = {
  tagId: string;
  tagName: string;
};

export type SpaceType = {
  spaceId: string;
  spaceUrl: string;
  pictureUrl?: string;
  description?: string;
  visible: boolean;
};

export type CertificateType = {
  id: string;
  verifyUrl: string;
  title: string;
  dateCompleted: number;
  visible: boolean;
};

export interface IInterests extends IDefault {
  tags: TagType[];
}

export interface ISpaces extends IDefault {
  spaces: SpaceType[];
}

export interface ICertificates extends IDefault {
  certificates: CertificateType[];
}

export interface IActivity extends IDefault {
  stars: number;
  lessonsRead: number;
  exercisePoints: number;
  quizPoints: number;
  totalPoints: number;
  challenges?: number;
}

export interface IDiscord extends IDefault {
  user: string;
  role: string;
  messages: string;
  experience: string;
  level: number;
}

export interface ICompetitionPerformance {
  topThreeFinishes: number;
  leaguePromotions: number;
  currentStreak: number;
  bestRank: number;
  topGlobal500Finishes?: number;
  bestTier?: {
    id: string;
    name: string;
    level: number;
  };
}

export interface IAsset {
  assetId: string;
  claimedAt?: string;
}

export interface IAvatar {
  layers: {
    head?: string;
    back?: string;
    face?: string;
    outfit?: string;
    accessory?: string;
  };
  version: number;
  colors: {
    eyes?: string;
    hair?: string;
    shirt?: string;
  };
  base: string;
}

export type AvatarSlot = 'head' | 'face' | 'outfit' | 'bottom' | 'feet' | 'back' | 'accessories' | 'base' | 'mood' | 'expression' | 'costume';

export const avatarSlotOrder: AvatarSlot[] = [
  'base',
  'costume',
  'expression',
  'head',
  'outfit',
  'bottom',
  'feet',
  'accessories',
  'back',
  'face',
  'mood',
];

export type AvatarUnlockType =
  | 'xp'
  | 'exercises'
  | 'practiceTest'
  | 'streak'
  | 'quiz'
  | 'course'
  | 'challenge'
  | 'certificate'
  | 'subscriptionMonths'
  | 'specialDate'
  | 'fullAccess'
  | 'free';

export interface SpecialZIndexConfig {
  zIndex: number;
}

export type SpecialZIndexConfigMap = Record<string, SpecialZIndexConfig>;

// Configuration for items that need special z-index handling
export const specialZIndexConfig: SpecialZIndexConfigMap = {
  catana: {
    zIndex: 0,
  },
  'paper-scroll': {
    zIndex: 0,
  },
};

export interface AvatarAppearanceV1 {
  version: 1;
  base: string;
  layers: Partial<Record<AvatarSlot, string>>;
  colors?: Record<string, string>;
}

export interface AvatarManifestItem {
  id: string;
  slot: AvatarSlot;
  z: number;
  unlockAt: number;
  name: string;
  svg: string;
  previewSvg?: string;
  slotLabel: string;
  unlockType: AvatarUnlockType;
  previewScale?: number;
  previewOffset?: { x: number; y: number };
}

export interface ICohortUser {
  id: string;
  userId?: string;
  nickname: string;
  weeklyXP: number;
  rank: number;
  booster: boolean;
  tier: string;
  avatar?: AvatarAppearanceV1;
}

export interface ICohort {
  users: ICohortUser[];
  userRank: number;
  totalUsers: number;
}

export interface IUserProfileConfiguration {
  id: string;
  userId: string;
  published: boolean;
  basic: IBasic;
  createdAt?: number;
  updatedAt?: number;
  socialMedias: ISocialMedia[];
  sections: (IDiscord | IActivity | ICertificates | ISpaces | IInterests | ISkill | IEducation | IExperience)[];
  competitionPerformance?: ICompetitionPerformance;
  assets?: IAsset[];
  cohort?: ICohort;
  subscriptionLevel?: string;
}

export interface IReportAbuse {
  name: string;
  email: string;
  profile: string;
  description: string;
}

export interface ISkill extends IDefault {
  skills: Skill[];
}

export interface Skill {
  id: string;
  name: string;
  level?: number;
  progress?: number;
  activities?: number;
  icon?: React.ElementType;
  visible?: boolean;
}

export interface IEducation extends IDefault {
  education: Education[];
}

export interface Education {
  degree?: string;
  period?: string;
  institution?: string;
  place?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
}

export interface IExperience extends IDefault {
  experience: Experience[];
}

export interface Experience {
  company?: string;
  period?: string;
  position?: string;
  location?: string;
  duties?: string[];
  dutiesString?: string;
  startDate?: string;
  endDate?: string;
}
